/* Sticky footer: mirror price HTML + update sticky button label (read-only) */
(function () {
  'use strict';

  function $(sel, root){ return (root||document).querySelector(sel); }

  function mainPriceWrap(){ return $('[data-main-price-wrap]'); }
  function stickyPriceWrap(){ return $('.product_sticky_cart [data-sticky-price-wrap]'); }

  // Clone the full HTML of the main price (keeps strike-through)
  function mirrorPriceHTML(){
    var src = mainPriceWrap(), dst = stickyPriceWrap();
    if (!src || !dst) return;
    var srcNode = src.querySelector('.price') || src; // copy the whole price block
    dst.innerHTML = '';
    dst.appendChild(srcNode.cloneNode(true));
  }

  // Grab formatted text (for button label)
  function readPlainPriceText(){
    var src = mainPriceWrap();
    if (!src) return '';
    var sale = src.querySelector('.price-item--sale');
    var reg  = src.querySelector('.price-item--regular, .price-item');
    var node = sale || reg || src;
    return (node.textContent || '').replace(/\s+/g,' ').trim();
  }

  // Find sticky submit button (in sticky form only)
  function stickyBtn(){
    var form = $('.product_sticky_cart form[action*="/cart/add"]');
    return form ? $('.product-form__submit', form) : null;
  }

  // Keep label “clean” (no hardcoded numbers), then append price text
  function updateStickyButton(){
    var btn = stickyBtn();
    if (!btn) return;

    var labelEl = btn.__labelEl || btn.querySelector('span') || btn;

    if (!btn.__base){
      var base = (labelEl.textContent || '')
        .replace(/[$€£]\s?\d[\d.,]*/g,'')
        .replace(/\d[\d.,]*\s?[$€£]/g,'')
        .replace(/\d[\d.,]+/g,'')
        .replace(/\s{2,}/g,' ')
        .trim();
      btn.__base = base || 'ADD TO CART';
      btn.__labelEl = labelEl;
    }

    var priceText = readPlainPriceText();
    btn.__labelEl.textContent = btn.__base + (priceText ? (' ' + priceText) : '');
  }

  function syncAll(){
    // 1) show the same (strike-through) price in sticky
    mirrorPriceHTML();
    // 2) update sticky button label with current price
    updateStickyButton();
  }

  document.addEventListener('DOMContentLoaded', function(){
    // run only if sticky footer exists
    if (!$('.product_sticky_cart')) return;

    // initial
    syncAll();

    // fire on common variant-change events (themes vary)
    ['variant:change','variant:changed','product:variant-change']
      .forEach(function(ev){ document.addEventListener(ev, syncAll, true); });

    // observe main price mutations (sale state/currency/theme re-render)
    var src = mainPriceWrap();
    if (src){
      new MutationObserver(syncAll)
        .observe(src, { childList:true, subtree:true, characterData:true });
    }

    // also observe variant id in the main (non-sticky) form
    var idInput = $('form[action*="/cart/add"]:not(.product_sticky_cart *) input[name="id"]');
    if (idInput){
      idInput.addEventListener('change', syncAll);
      idInput.addEventListener('input', syncAll);
      new MutationObserver(syncAll)
        .observe(idInput, { attributes:true, attributeFilter:['value'] });
    }

    // warm-up (lazy inserts, currency apps, etc.)
    var tries = 0, t = setInterval(function(){
      syncAll();
      if (++tries > 20) clearInterval(t);
    }, 250);
  });
})();
/* === PATCH: force-update sticky button label price (regex replace) === */
(function () {
  'use strict';

  // взять текст цены из левого ценника (sale -> regular)
  function readMainPriceText() {
    var wrap = document.querySelector('[data-main-price-wrap]');
    if (!wrap) return '';
    var sale = wrap.querySelector('.price-item--sale');
    var reg  = wrap.querySelector('.price-item--regular, .price-item');
    var node = sale || reg || wrap;
    return (node.textContent || '').replace(/\s+/g,' ').trim();
  }

  // выделить «ценовой» токен из текста (поддержка $ € £ и форматов 1 299,00 / 1,299.00 / 1299)
  function extractPriceToken(txt) {
    if (!txt) return '';
    var m = txt.match(/([$€£]\s?\d[\d.,]*|\d[\d.,]*\s?[$€£])/);
    return m ? m[0].trim() : txt;
  }

  // найти sticky-кнопку и её «лейбл»-элемент
  function getStickyBtnAndLabel() {
    var stickyForm = document.querySelector('.product_sticky_cart form[action*="/cart/add"]');
    if (!stickyForm) return {};
    var btn = stickyForm.querySelector('.product-form__submit');
    if (!btn) return {};
    var label = btn.querySelector('span') || btn; // в Dawn обычно первый <span>
    return { btn: btn, label: label };
  }

  // очистить базовый лейбл от любых чисел/валют один раз
  function getBaseLabel(el) {
    if (el.__baseLabel) return el.__baseLabel;
    var base = (el.textContent || '')
      .replace(/[$€£]\s?\d[\d.,]*/g,'')   // $1299 / € 1.299,00
      .replace(/\d[\d.,]*\s?[$€£]/g,'')   // 1 299 € / 1,299$
      .replace(/\d[\d.,]+/g,'')           // «голые» числа
      .replace(/\s{2,}/g,' ')
      .trim();
    el.__baseLabel = base || 'ADD TO CART';
    return el.__baseLabel;
  }

  function updateStickyButtonPrice() {
    var bits = getStickyBtnAndLabel();
    if (!bits.btn || !bits.label) return;

    var priceText = extractPriceToken(readMainPriceText());
    var base = getBaseLabel(bits.label);

    // Текущее содержимое без «мусора»
    var current = (bits.label.textContent || '').replace(/\s+/g,' ').trim();

    // Если внутри уже была цена — просто заменим её на новую
    var replaced = current.replace(
      /([$€£]\s?\d[\d.,]*|\d[\d.,]*\s?[$€£])/,
      priceText || '$0'
    );

    // Если цена не нашлась в тексте — соберём «БАЗА + ЦЕНА»
    if (replaced === current) {
      replaced = base + (priceText ? (' ' + priceText) : '');
    } else {
      // гарантируем, что префикс ровно базовый
      replaced = base + (priceText ? (' ' + priceText) : '');
    }

    if (bits.label.textContent !== replaced) {
      bits.label.textContent = replaced;
    }
  }

  // запуск и «триггеры»
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('.product_sticky_cart')) return;

    // первичный апдейт
    updateStickyButtonPrice();

    // события смены варианта (разные темы)
    ['variant:change','variant:changed','product:variant-change']
      .forEach(function (ev) {
        document.addEventListener(ev, updateStickyButtonPrice, true);
      });

    // наблюдаем левый ценник (перерисовки темы/валюта/скидка)
    var src = document.querySelector('[data-main-price-wrap]');
    if (src) {
      new MutationObserver(updateStickyButtonPrice)
        .observe(src, { childList:true, subtree:true, characterData:true });
    }

    // фолбек: следим за hidden input с variant id (в основной форме)
    var idInput = document.querySelector('form[action*="/cart/add"]:not(.product_sticky_cart *) input[name="id"]');
    if (idInput) {
      ['change','input'].forEach(function (ev) { idInput.addEventListener(ev, updateStickyButtonPrice); });
      new MutationObserver(updateStickyButtonPrice)
        .observe(idInput, { attributes:true, attributeFilter:['value'] });
    }

    // небольшой прогрев (ленивые вставки)
    var i = 0, t = setInterval(function(){
      updateStickyButtonPrice();
      if (++i > 20) clearInterval(t);
    }, 250);
  });
})();
(function () {
  'use strict';

  // Находим оба инпута variant id
  function findVariantInputs() {
    var all = document.querySelectorAll('input.product-variant-id[name="id"]');
    var main = null, sticky = null;
    all.forEach(function (el) {
      if (el.closest('.product_sticky_cart')) sticky = el;
      else main = el; // первый не в sticky считаем «верхним»
    });
    return { main: main, sticky: sticky };
  }

  function getCurrentVariantId(inputs) {
    // 1) пробуем из верхнего инпута
    if (inputs.main && inputs.main.value) return inputs.main.value;
    // 2) пробуем из URL (?variant=)
    var m = location.search.match(/[?&]variant=(\d+)/);
    if (m) return m[1];
    return '';
  }

  function syncStickyVariantId() {
    var ins = findVariantInputs();
    if (!ins.main || !ins.sticky) return;
    var v = getCurrentVariantId(ins);
    if (!v) return;

    // снимаем disabled на всякий случай
    ins.sticky.disabled = false;

    // копируем значение
    if (ins.sticky.value !== v) {
      ins.sticky.value = v;
      // дёрнем событие для совместимости
      ins.sticky.dispatchEvent(new Event('input', { bubbles: true }));
      ins.sticky.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // если нет sticky-блока — выходим
    if (!document.querySelector('.product_sticky_cart')) return;

    // первичный прогон
    syncStickyVariantId();

    // Ловим любые события смены варианта (разные темы называют по-разному)
    ['change','input','variant:change','variant:changed','product:variant-change']
      .forEach(function (ev) {
        document.addEventListener(ev, syncStickyVariantId, true);
      });

    // Следим, когда тема меняет value у ВЕРХНЕГО инпута
    var ins = findVariantInputs();
    if (ins.main) {
      new MutationObserver(syncStickyVariantId)
        .observe(ins.main, { attributes:true, attributeFilter:['value'] });
    }

    // Перед отправкой sticky-формы гарантированно синхронизируем
    var stickyForm = document.querySelector('.product_sticky_cart form[action*="/cart/add"]');
    if (stickyForm) stickyForm.addEventListener('submit', syncStickyVariantId);

    // Фолбек: несколько попыток после загрузки (если рендер идёт лениво)
    var i = 0, t = setInterval(function(){
      syncStickyVariantId();
      if (++i > 20) clearInterval(t);
    }, 250);
  });
})();
